import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/employee-activities/export-pdf`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const exportPDF = {
  get: apiPathFunc(pathBase),
};
